import { useState, useEffect, React } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUpFromBracket,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import { Toaster, toast } from "react-hot-toast";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { createEvent, updateEvent, getEvent, getAllClubs } from "actions/action";
import { imageBaseURL } from "actions/Base_URL";
import SubmittingModal from "components/Modal";

const CreateEvent = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { type, id } = location.state;

  const user_id = localStorage.getItem("user_id");
  let viewFlag = false;
  let getUserId = "";
  const [updateFlag, setUpdateFlag] = useState(false);

  if (window.location.href.includes("/create-event/id:")) {
    let getExtractUrl = window.location.href.split("/create-event/id:")[1];
    if (getExtractUrl) {
      let splitUrl = getExtractUrl.split("/viewFlag=");
      getUserId = splitUrl[0] || "";
      viewFlag = splitUrl[1] === "true";
    }
  }

  const formatDate = (date) => {
    return date ? dayjs(date).format("YYYY-MM-DD HH:mm:ss") : null;
  };

  const [formData, setFormData] = useState({
    event_name: "",
    start_date: "",
    end_date: "",
    reg_start_date: "",
    reg_end_date: "",
    description: "",
    created_by: user_id,
    form_inputs: [],
    banner: "",
    existing_images: [],
    event_images: [],
    allow_image_upload: false,
    allow_ppt_upload: false,
    restricted_clubs: [],
  });
  const getRole = () => {
    const token = localStorage.getItem("token");
    if (!token) return null;
    try {
      return jwtDecode(token).role;
    } catch {
      return null;
    }
  };
  const role = getRole();

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [dynamicFields, setDynamicFields] = useState([]);
  const [selectedFieldType, setSelectedFieldType] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [dropdownOptions, setDropdownOptions] = useState("");
  const [clubs, setClubs] = useState([]);

  useEffect(() => {
    fetchClubs();
  }, []);

  const fetchClubs = async () => {
    try {
      const res = await getAllClubs();
      if (res.success) {
        setClubs(res.data);
      }
    } catch (error) {
      console.error("Error fetching clubs:", error);
    }
  };

  const inputFieldArray = [
    { id: 1, fieldName: "Contact Number", type: "tel" },
    { id: 2, fieldName: "Email Id", type: "email" },
    { id: 3, fieldName: "Placeholder", type: "text" },
    { id: 4, fieldName: "Description", type: "textarea" },
    { id: 5, fieldName: "Dropdown", type: "select" },
    { id: 6, fieldName: "Full Name", type: "text" },
    { id: 7, fieldName: "File Attachment", type: "file" },
    { id: 8, fieldName: "Password", type: "password" },
  ];

  const validate = () => {
    let newErrors = {};
    if (!formData.event_name) newErrors.event_name = "Event name is required";
    if (!formData.start_date) newErrors.start_date = "Start date is required";
    if (!formData.end_date) newErrors.end_date = "End date is required";
    if (!formData.description)
      newErrors.description = "Description is required";
    if (!formData.created_by) newErrors.created_by = "Creator name is required";
    if (type === "create" && formData.event_images.length === 0)
      newErrors.event_images = "Event image is required";
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  async function getEventDataById(id) {
    try {
      const token = localStorage.getItem("token");

      const response = await getEvent(id);
      console.log(response);
      if (response.data.data) {
        const restrictedClubsData = response.data.data.restricted_clubs;

        setFormData({
          event_name: response.data.data.event_name,
          existing_images: response.data.data.event_images,
          start_date: response.data.data.start_date
            ? dayjs(response.data.data.start_date).format("YYYY-MM-DDTHH:mm")
            : "",
          end_date: response.data.data.end_date
            ? dayjs(response.data.data.end_date).format("YYYY-MM-DDTHH:mm")
            : "",
          reg_start_date: response.data.data.reg_start_date
            ? dayjs(response.data.data.reg_start_date).format(
              "YYYY-MM-DDTHH:mm"
            )
            : "",
          reg_end_date: response.data.data.reg_end_date
            ? dayjs(response.data.data.reg_end_date).format("YYYY-MM-DDTHH:mm")
            : "",
          description: response.data.data.description,
          created_by: user_id,
          form_inputs: response.data.data.form_inputs,
          banner: "",
          allow_image_upload: response.data.data.allow_image_upload || false,
          allow_ppt_upload: response.data.data.allow_ppt_upload || false,
          restricted_clubs: (() => {
            let rc = restrictedClubsData;
            if (typeof rc === 'string') {
              try {
                rc = JSON.parse(rc);
              } catch (e) {
                console.error("Error parsing restricted_clubs:", e);
                rc = [];
              }
            }
            return Array.isArray(rc) ? rc : [];
          })(),
        });

        const dynamicInputs = JSON.parse(response.data.data.form_inputs);
        const formattedFields = dynamicInputs.map((field) => {
          return {
            id: Date.now() + field.fieldName + field.fieldType,
            type: field.fieldType,
            name: field.fieldName.toLowerCase().replace(/\s+/g, "_"),
            label: field.fieldName,
            options:
              field.fieldType === "select"
                ? dropdownOptions.split(",").map((opt) => opt.trim())
                : [],
            value: "",
          };
        });

        setDynamicFields([...dynamicFields, ...formattedFields]);
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  }

  useEffect(() => {
    if (type !== "create") getEventDataById(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleChange = (e) => {
    if (e.target.name === "event_images" || e.target.name === "banner") {
      const files = Array.from(e.target.files);
      const validFiles = [];
      let hasError = false;

      files.forEach(file => {
        if (file.size > 2 * 1024 * 1024) {
          toast.error(`Image ${file.name} exceeds 2MB limit.`);
          hasError = true;
        } else {
          // Optional: You could add async resolution check here if needed, 
          // but synchronous handleChange is simpler for now. 
          // For strict resolution check, usage of Promise is needed similar to StudentEventRegistration.
          validFiles.push(file);
        }
      });

      if (!hasError) {
        if (e.target.name === "event_images") {
          setFormData({ ...formData, [e.target.name]: e.target.files }); // Keeping original FileList if valid
        } else {
          setFormData({ ...formData, [e.target.name]: e.target.files[0] });
        }
      } else {
        e.target.value = null; // Clear input on error
      }

    } else if (e.target.type === "checkbox") {
      setFormData({ ...formData, [e.target.name]: e.target.checked });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleFieldTypeChange = (e) => {
    setSelectedFieldType(e.target.value);
  };

  const addDynamicField = () => {
    if (!selectedFieldType) return;

    const fieldType = inputFieldArray.find(
      (field) => field.fieldName === selectedFieldType
    );
    if (!fieldType) return;

    const newField = {
      id: Date.now(),
      type: fieldType.type,
      name: fieldName || fieldType.fieldName.toLowerCase().replace(/\s+/g, "_"),
      label: fieldName || fieldType.fieldName,
      options:
        fieldType.type === "select"
          ? dropdownOptions.split(",").map((opt) => opt.trim())
          : [],
      value: "",
    };

    setDynamicFields([...dynamicFields, newField]);
    setSelectedFieldType("");
    setFieldName("");
    setDropdownOptions("");
  };

  const handleDynamicFieldChange = (id, value) => {
    setDynamicFields(
      dynamicFields.map((field) =>
        field.id === id ? { ...field, value } : field
      )
    );
  };

  const handleFileUpload = (id, e) => {
    const file = e.target.files[0];
    setDynamicFields(
      dynamicFields.map((field) =>
        field.id === id ? { ...field, value: file } : field
      )
    );
  };

  const removeDynamicField = (id) => {
    setDynamicFields(dynamicFields.filter((field) => field.id !== id));
  };

  async function handleSubmit(e) {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const formattedFields = dynamicFields.map((field) => {
        const fieldObj = {
          fieldName: field.label,
          fieldType: field.type,
        };
        if (field.type === "select") {
          fieldObj.options = field.options;
        }
        return fieldObj;
      });

      const formDataToSend = new FormData();
      formDataToSend.append("event_name", formData.event_name);
      formDataToSend.append("start_date", formData.start_date);
      formDataToSend.append("end_date", formData.end_date);
      if (formData.reg_start_date)
        formDataToSend.append("reg_start_date", formData.reg_start_date);
      if (formData.reg_end_date)
        formDataToSend.append("reg_end_date", formData.reg_end_date);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("created_by", user_id);
      formDataToSend.append("form_inputs", JSON.stringify(formattedFields));
      formDataToSend.append("allow_image_upload", formData.allow_image_upload);
      formDataToSend.append("allow_ppt_upload", formData.allow_ppt_upload);
      formDataToSend.append("restricted_clubs", JSON.stringify(formData.restricted_clubs));
      // if(formData.event_images && formData.event_images.length !== 0){
      //   Array.from(formData.event_images).forEach((image) => {
      //       formDataToSend.append("event_images", image); // append all selected images
      //     });
      // }
      if (formData.event_images && formData.event_images.length > 0) {
        Array.from(formData.event_images).forEach((image) => {
          if (image instanceof File && image.type.startsWith("image/")) {
            formDataToSend.append("event_images", image);
          }
        });
      }
      // if(formData.existing_images && formData.existing_images.length !== 0){
      //   Array.from(formData.existing_images).forEach((image) => {
      //       formDataToSend.append("existing_images", image); // append all selected images
      //     });
      // }

      if (formData.existing_images && formData.existing_images.length > 0) {
        formDataToSend.append(
          "existing_images",
          JSON.stringify(formData.existing_images)
        );
      }

      if (formData.banner instanceof File) {
        formDataToSend.append("banner", formData.banner);
      }
      console.log(
        "Submitting formDataToSend:",
        Object.fromEntries(formDataToSend)
      );
      if (type === "create") {
        const res = await createEvent(formDataToSend);
        if (res.success) {
          toast.success("Event created successfully!");
        } else {
          const errorMessage = res.err?.response?.data?.message || res.err?.message || "Failed to create event";
          toast.error(errorMessage);
        }
      } else {
        const res = await updateEvent(formDataToSend, id);
        if (res.success) {
          toast.success("Event updated successfully!");
        } else {
          const errorMessage = res.err?.response?.data?.message || res.err?.message || "Failed to update event";
          toast.error(errorMessage);
        }
      }

      clearFormData();
      setDynamicFields([]);
      setLoading(false);
      setTimeout(() => {
        navigate(`/${role}/events`);
      }, 1000);
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      toast.error("Something went wrong");
      setLoading(false);
    }
  }

  const groupFieldsIntoColumns = () => {
    const leftColumnFields = [];
    const rightColumnFields = [];

    dynamicFields.forEach((field, index) => {
      if (index % 2 === 0) {
        leftColumnFields.push(field);
      } else {
        rightColumnFields.push(field);
      }
    });

    return { leftColumnFields, rightColumnFields };
  };

  const renderFieldInput = (field) => {
    switch (field.type) {
      case "text":
      case "email":
      case "tel":
        return (
          <input
            type={field.type}
            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            value={field.value}
            onChange={(e) => handleDynamicFieldChange(field.id, e.target.value)}
            placeholder={`Enter ${field.label.toLowerCase()}`}
            disabled={type === "view" ? true : false}
          />
        );
      case "password":
        return (
          <input
            type={field.type}
            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            value={field.value}
            onChange={(e) => handleDynamicFieldChange(field.id, e.target.value)}
            placeholder={`Enter ${field.label.toLowerCase()}`}
          />
        );
      case "textarea":
        return (
          <textarea
            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            value={field.value}
            onChange={(e) => handleDynamicFieldChange(field.id, e.target.value)}
            placeholder={`Enter ${field.label.toLowerCase()}`}
            rows="3"
          />
        );
      case "select":
        return (
          <select
            className="border-0 px-3 py-3 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
            value={field.value}
            onChange={(e) => handleDynamicFieldChange(field.id, e.target.value)}
          >
            <option value="">Select an option</option>
            {field.options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        );
      case "file":
        return (
          <div className="flex items-center">
            <label className="cursor-pointer">
              <div className="flex items-center">
                <span className="bg-lightBlue-500 mt-2 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">
                  <FontAwesomeIcon icon={faArrowUpFromBracket} />
                  {"  "}
                  Upload File
                </span>
                <span className="ml-3 text-sm text-blueGray-600">
                  {field.value ? field.value.name : "No file chosen"}
                </span>
              </div>
              <input
                type="file"
                className="hidden"
                onChange={(e) => handleFileUpload(field.id, e)}
              />
            </label>
            {field.value && (
              <button
                type="button"
                onClick={() => handleDynamicFieldChange(field.id, null)}
                className="ml-3 text-red-500 hover:text-red-700 text-xs font-bold"
              >
                Remove
              </button>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  const renderFieldColumn = (fields) => {
    return (
      <div className="w-full lg:w-6/12 px-4">
        {fields.map((field) => (
          <div key={field.id} className="relative w-full mb-3">
            <label className="block text-blueGray-600 text-xs font-bold mb-2">
              {field.label}
            </label>
            <div className="flex items-center">
              <div className="flex-grow">{renderFieldInput(field)}</div>
              <button
                type="button"
                onClick={() => removeDynamicField(field.id)}
                className={`ml-2 text-red-500 hover:text-red-700 text-xs font-bold ${type === "view" ? "hidden" : ""
                  }`}
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const handleImageChange = (indexToRemove) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      existing_images: prevFormData.existing_images.filter(
        (_, index) => index !== indexToRemove
      ),
    }));
  };

  const { leftColumnFields, rightColumnFields } = groupFieldsIntoColumns();

  function clearFormData() {
    setUpdateFlag(false);
    setFormData({
      event_name: "",
      existing_images: [],
      event_images: [],
      start_date: "",
      end_date: "",
      description: "",
      created_by: user_id,
      form_inputs: [],
      banner: "",
      allow_image_upload: false,
      allow_ppt_upload: false,
    });
  }

  return (
    <>
      <Toaster position="bottom-left" reverseOrder={false} />
      <SubmittingModal loading={loading} />
      <div className="flex justify-center items-center">
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 mt-6 shadow-lg rounded-lg bg-dark-secondary border-0">
          <div className="rounded-t bg-dark-tertiary mb-0 px-6 py-6">
            <div className="text-center flex justify-between">
              <h6 className="text-white text-xl font-bold">
                {type === "view"
                  ? "View Form"
                  : type === "create"
                    ? "Create Form"
                    : "Update Form"}
              </h6>
            </div>
          </div>
          <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
            <form>
              <h6 className="text-gray-400 text-sm mt-3 mb-6 font-bold">
                Event Information
              </h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-gray-300 text-xs font-bold mb-2">
                      Event Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="event_name"
                      value={formData.event_name}
                      onChange={handleChange}
                      readOnly={viewFlag}
                      className="border-0 px-3 py-3 placeholder-gray-500 text-white bg-dark-primary rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Enter event name"
                      disabled={type === "view" ? true : false}
                    />
                    {errors.event_name && (
                      <p className="text-red-500 text-xs">
                        {errors.event_name}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div
                    className={`relative w-full mb-3 ${type === "view" ? "hidden" : ""
                      }`}
                  >
                    <label className="block text-gray-300 text-xs font-bold mb-2">
                      Event Image <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      name="event_images"
                      onChange={handleChange}
                      // readOnly={viewFlag}
                      className="border-0 px-3 py-2 placeholder-gray-500 text-white bg-dark-primary rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Enter event name"
                      disabled={type === "view" ? true : false}
                    />
                    {errors.event_images && (
                      <p className="text-red-500 text-xs">
                        {errors.event_images}
                      </p>
                    )}
                  </div>
                </div>
                {type === "edit" || "view" ? (
                  <>
                    <div className="w-full lg:w-12/12 px-4">
                      <div className="relative w-full mb-3">
                        <label className="block text-gray-300 text-xs font-bold mb-2">
                          Existing Image
                        </label>
                        {formData.existing_images &&
                          formData.existing_images.map((imageUrl, index) => {
                            const newImageUrl = imageUrl.replace(/^[^_]*_/, "");
                            return (
                              <div key={index}>
                                <button
                                  key={index}
                                  type="button"
                                  onClick={() =>
                                    window.open(
                                      `${imageBaseURL}${imageUrl}`,
                                      "_blank"
                                    )
                                  } // opens in new tab
                                  className="w-10/12 bg-dark-primary text-white border border-white/10 rounded-md py-2 px-4 my-2 shadow hover:bg-white/5 transition"
                                >
                                  {newImageUrl}
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleImageChange(index)}
                                  style={{ width: "50px" }}
                                  className={`bg-dark-primary text-red-400 hover:text-red-300 border border-white/10 rounded-md py-2 px-4 my-2 shadow hover:bg-white/5 transition ${type === "view" ? "hidden" : ""
                                    }`}
                                >
                                  ✕
                                </button>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </>
                ) : null}
              </div>

              <hr className="mt-6 border-b-1 border-blueGray-300" />
              <h6 className="text-gray-400 text-sm mt-3 mb-6 font-bold">
                Event Schedule
              </h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-gray-300 text-xs font-bold mb-2">
                      Start Date & Time <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="datetime-local"
                      name="start_date"
                      value={formData.start_date}
                      onChange={handleChange}
                      readOnly={viewFlag}
                      className="border-0 px-3 py-3 placeholder-gray-500 text-white bg-dark-primary rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      disabled={type === "view" ? true : false}
                    />
                    {errors.start_date && (
                      <p className="text-red-500 text-xs">
                        {errors.start_date}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-gray-300 text-xs font-bold mb-2">
                      End Date & Time <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="datetime-local"
                      name="end_date"
                      value={formData.end_date}
                      onChange={handleChange}
                      className="border-0 px-3 py-3 placeholder-gray-500 text-white bg-dark-primary rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      disabled={type === "view" ? true : false}
                    />
                    {errors.end_date && (
                      <p className="text-red-500 text-xs">{errors.end_date}</p>
                    )}
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2">
                      Registration Start Date & Time
                    </label>
                    <input
                      type="datetime-local"
                      name="reg_start_date"
                      value={formData.reg_start_date}
                      onChange={handleChange}
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      disabled={type === "view" ? true : false}
                    />
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2">
                      Registration End Date & Time
                    </label>
                    <input
                      type="datetime-local"
                      name="reg_end_date"
                      value={formData.reg_end_date}
                      onChange={handleChange}
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      disabled={type === "view" ? true : false}
                    />
                  </div>
                </div>
              </div>

              <hr className="mt-6 border-b-1 border-blueGray-300" />
              <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold">
                Student Upload Configuration
              </h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3 flex items-center">
                    <input
                      type="checkbox"
                      name="allow_image_upload"
                      id="allow_image_upload"
                      checked={formData.allow_image_upload}
                      onChange={handleChange}
                      disabled={type === "view"}
                      className="form-checkbox h-5 w-5 text-lightBlue-600 rounded border-gray-300 focus:ring-lightBlue-500 mr-2"
                    />
                    <label
                      htmlFor="allow_image_upload"
                      className="block text-blueGray-600 text-sm font-bold pt-1 cursor-pointer"
                    >
                      Allow Image Upload
                    </label>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3 flex items-center">
                    <input
                      type="checkbox"
                      name="allow_ppt_upload"
                      id="allow_ppt_upload"
                      checked={formData.allow_ppt_upload}
                      onChange={handleChange}
                      disabled={type === "view"}
                      className="form-checkbox h-5 w-5 text-lightBlue-600 rounded border-gray-300 focus:ring-lightBlue-500 mr-2"
                    />
                    <label
                      htmlFor="allow_ppt_upload"
                      className="block text-blueGray-600 text-sm font-bold pt-1 cursor-pointer"
                    >
                      Allow PPT Upload
                    </label>
                  </div>
                </div>
                <div className="w-full lg:w-12/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2">
                      Restricted Clubs (Select to block registration for club members)
                    </label>
                    <div className="h-48 overflow-y-auto border rounded px-3 py-2 bg-white">
                      {clubs.length === 0 && <p className="text-gray-500 text-sm p-2">No clubs found. Please create clubs in the Admin panel first.</p>}
                      {clubs.map(club => (
                        <div key={club.club_id} className="flex items-center mb-2">
                          <input
                            type="checkbox"
                            id={`club-${club.club_id}`}
                            value={club.club_id}
                            checked={formData.restricted_clubs?.includes(String(club.club_id))}
                            onChange={(e) => {
                              const clubId = String(club.club_id);
                              const isChecked = e.target.checked;
                              setFormData(prev => {
                                const currentRestricted = prev.restricted_clubs || [];
                                if (isChecked) {
                                  return { ...prev, restricted_clubs: [...currentRestricted, clubId] };
                                } else {
                                  return { ...prev, restricted_clubs: currentRestricted.filter(id => id !== clubId) };
                                }
                              });
                            }}
                            className="form-checkbox h-4 w-4 text-lightBlue-600 rounded border-gray-300 mr-2"
                          />
                          <label htmlFor={`club-${club.club_id}`} className="text-sm text-gray-700 cursor-pointer select-none">
                            {club.club_name}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <hr className="mt-6 border-b-1 border-blueGray-300" />
              <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold">
                Description
              </h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-12/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2">
                      Description <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      readOnly={viewFlag}
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Enter your description."
                      rows="4"
                      disabled={type === "view" ? true : false}
                    />
                    {errors.description && (
                      <p className="text-red-500 text-xs">
                        {errors.description}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {type !== "view" ? (
                <>
                  <hr className="mt-6 border-b-1 border-blueGray-300" />
                  <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold">
                    Add Form
                  </h6>
                  <div className="flex flex-wrap">
                    <div className="w-full lg:w-4/12 px-4">
                      <div className="relative w-full mb-3">
                        <label className="block text-blueGray-600 text-xs font-bold mb-2">
                          Field Type
                        </label>
                        <select
                          className="border-0 px-3 py-3 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                          value={selectedFieldType}
                          onChange={handleFieldTypeChange}
                        >
                          <option value="">Select a field type</option>
                          {inputFieldArray.map((x) => (
                            <option key={x.id} value={x.fieldName}>
                              {x.fieldName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="w-full lg:w-4/12 px-4">
                      <div className="relative w-full mb-3">
                        <label className="block text-blueGray-600 text-xs font-bold mb-2">
                          Field Name
                        </label>
                        <input
                          type="text"
                          value={fieldName}
                          onChange={(e) => setFieldName(e.target.value)}
                          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          placeholder="Enter field name"
                          disabled={type === "view" ? true : false}
                        />
                      </div>
                    </div>

                    {selectedFieldType === "Dropdown" && (
                      <div className="w-full lg:w-4/12 px-4">
                        <div className="relative w-full mb-3">
                          <label className="block text-blueGray-600 text-xs font-bold mb-2">
                            Add Values
                          </label>
                          <input
                            type="text"
                            value={dropdownOptions}
                            onChange={(e) => setDropdownOptions(e.target.value)}
                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                            placeholder="Option 1, Option 2, Option 3"
                          />
                        </div>
                      </div>
                    )}

                    <div className="flex flex-wrap">
                      <div className="w-full lg:w-2/12 px-4 flex items-end mb-4">
                        <Tooltip title="Add">
                          <button
                            type="button"
                            onClick={addDynamicField}
                            className="bg-lightBlue-500 mt-6 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                          >
                            <i className="fas fa-plus mr-2" />
                            Add
                          </button>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
              <hr className="mt-6 border-b-1 border-blueGray-300" />
              <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold">
                Preview Form
              </h6>
              <div className="mt-6 flex flex-wrap">
                {/* {renderFieldColumn(dynamicFields)} */}
                {renderFieldColumn(leftColumnFields)}
                {renderFieldColumn(rightColumnFields)}
              </div>
              <div className="flex justify-end w-full">
                <Tooltip title="Back" arrow>
                  <button
                    className="mt-10 text-white bg-blueGray-700 active:bg-blueGray-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-auto ease-linear transition-all duration-150"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`/${role}/events`);
                    }}
                  >
                    {"<< "}Back
                  </button>
                </Tooltip>
                {type !== "view" ? (
                  <>
                    <Tooltip title="Submit" arrow>
                      <button
                        className="bg-lightBlue-500 mt-10 text-white active:bg-lightBlue-600 font-semibold  text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                        type="submit"
                        onClick={handleSubmit}
                      >
                        {type === "create" ? "Submit" : "Update"}
                      </button>
                    </Tooltip>
                    <Tooltip title="Clear" arrow>
                      <button
                        className="bg-red-500 mt-10 text-white active:bg-lightBlue-600 font-semibold  text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          clearFormData();
                        }}
                      >
                        Clear
                      </button>
                    </Tooltip>
                  </>
                ) : (
                  ""
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateEvent;
